module.exports = "https://cdn.dove.it/_next/static/public/assets/features/feature_6.f6c4ddcaf365ce8922d34e8cdda4272a.png";